// @ts-nocheck
import { OrderChangeRequestLineStateModel } from "@store/Framework/Types/ApiModels";
import { orderChangeRequestLineReasons } from "@store/Library/Components/OrderChangeRequest/OrderChangeRequestLineForm";
import { ProductLineStatusType } from "@store/Library/Components/ProductLine/ProductLineStatusOverlay";

const getOrderChangeRequestProductLineStatus = (
    lineState: OrderChangeRequestLineStateModel | undefined,
): ProductLineStatusType | undefined => {
    if (!lineState) {
        return undefined;
    }

    const { isCanceled, changeNotes, changeReason, newQuantity } = lineState;

    if (isCanceled) {
        return "canceled";
    }

    if (changeReason === orderChangeRequestLineReasons.newProduct) {
        return "added";
    }

    if (changeReason || changeNotes || newQuantity) {
        return "modified";
    }

    return undefined;
};

export default getOrderChangeRequestProductLineStatus;
